import axios from "axios";
import {
  GetSearchWordsAsArray,
  MapSearchTermtoExpectedStreetTypes
} from "./tools";

class BusAPI {
  static callData(proxyServiceUrl) {
    const options = {
      method: "GET",
      headers: {
        "content-type": "text/xml; charset=utf-8",
        "Cache-Control": "no-cache"
      },
      url: proxyServiceUrl
    };

    try {
      const data = axios(options);
      return data;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  static getPlatformTag(platformNo) {
    const completeUrl = "/api/gis";

    const options = {
      method: "GET",
      url: completeUrl,
      headers: {
        "content-type": "application/json; charset=utf-8",
        "Cache-Control": "no-cache"
      },
      params: {
        platformNo
      }
    };

    try {
      const data = axios(options);
      return data;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  static getPlatformsForStreet(roadSearchText) {
    const searchTerms = GetSearchWordsAsArray(roadSearchText);
    const whereClause = [];
    for (let i = 0; i < searchTerms.length; i += 1) {
      const streetType = MapSearchTermtoExpectedStreetTypes(searchTerms[i]);
      if (streetType === "") {
        whereClause.push(searchTerms[i]);
      } else {
        whereClause.push(streetType);
      }
    }

    const completeUrl = "/api/gis";

    const options = {
      method: "POST",
      url: completeUrl,
      headers: {
        "content-type": "application/json; charset=utf-8",
        "Cache-Control": "no-cache"
      },
      params: {
        street: whereClause
      }
    };

    try {
      return axios(options);
    } catch (error) {
      console.error(error);
      return false;
    }
  }
}

export default BusAPI;
